import { render, staticRenderFns } from "./ShippedOrdersList.vue?vue&type=template&id=1b90d228&scoped=true"
import script from "./ShippedOrdersList.vue?vue&type=script&lang=js"
export * from "./ShippedOrdersList.vue?vue&type=script&lang=js"
import style0 from "./ShippedOrdersList.vue?vue&type=style&index=0&id=1b90d228&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_f8be560a05ba39e4779a4b3800f88bf1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b90d228",
  null
  
)

export default component.exports